import BaseMapper from '../../BaseMapper';

const FeedStatusUpdateMapper = (data, context) => {
    return data;
};

export default FeedStatusUpdateMapper;
